export default "__VITE_ASSET__BVH0qrlg__"